
import variables from '@/assets/css/utils.scss'
import {PathName} from "@/constant/routeData";

export default {
  name: 'HomeSide',
  components: {},
  props: {
    enableAsideHidden: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    asideHidden() {
      return this.$store.state.sidebar.asideHidden
    },
    asideWidth() {
      return variables['asideWidth']
    }
  },
  methods: {
    handleChangeRouter(url: PathName) {
      this.$router.push({name: url})
    },

    handleOpenRouter(url: PathName) {
      let routeData = this.$router.resolve({ name: url});
      window.open(routeData.href, '_blank');
    },

    handleClick() {
      this.$store.commit('SET_ASIDEHIDDEN', !this.asideHidden)
    }
  },
}
